/**
 * created by li si yi
 * 在线用户列表
 */
import React from 'react'
import "antd/dist/antd.css";
import {Button, Input, Pagination} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import moment from "moment";
import {getOnlineNumberList} from "../../../actions/onlineNumberInfo";
import BaseComponent from "../../../base/BaseComponent";

const {Search} = Input;

export default class OnlineNumberInfo extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            start: 1, //当前页
            size: 10, //每页条数
            listTotal: 0, //列表总数
            totalCount: 0, //总在线人数
            searchValue: null, //搜索文字
            dataList: [], //列表数据
            columns: [
                {
                    key: '1',
                    title: '账号',
                    dataIndex: 'userAccount',
                    width: "200px",
                    ellipsis: true
                },
                {
                    key: '2',
                    title: '登录IP',
                    dataIndex: 'ip',
                    textWrap: 'word-break',
                    width: "200px",
                    ellipsis: true
                },
                {
                    key: '3',
                    title: '登录时间',
                    dataIndex: 'loginTime',
                    width: "200px",
                    render: (text) => {
                        return <div>{text ? moment(text ? text : "").format('YYYY-MM-DD HH:mm:ss') : ''}</div>
                    }
                }
            ]
        };
    }

    componentDidMount() {
        this.getDataSource();
    }

    // 在线人数信息列表
    getDataSource() {
        let params = {
            pageNum: this.state.start,
            pageSize: this.state.size,
            account: window.top.currentUser.account
        };
        if (this.state.searchValue) {
            params.queryStr = this.state.searchValue
        }
        getOnlineNumberList(params, (res) => {
            let dataList = [];
            let listTotal = 0;
            let totalCount = 0;
            if (res && res.data) {
                dataList = res.data;
                listTotal = res.count;
                totalCount = res.totalCount
            }
            this.setState({
                dataList,
                listTotal,
                totalCount
            })
        })
    }

    // 重置
    reset = () => {
        this.setState({
            start: 1,
            size: 10
        });
        this.state.searchValue = null;
        this.getDataSource();
    };

    //搜索
    onSearch(value) {
        this.state.searchValue = value;
        this.state.start = 1;
        this.state.size = 10;
        this.getDataSource();
    };

    render() {
        const {totalCount} = this.state;
        return (
            <div style={{margin: "15px"}}>
                <div
                    style={{
                        backgroundColor: "#fff",
                        width: "100%",
                        maxHeight: 'calc(100vh - 100px)',
                        borderRadius: '5px',
                        paddingTop: 24
                    }}
                >
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 32px 24px",
                    }}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{width: "250px"}}>
                                <Search
                                    placeholder="请输入账号"
                                    onSearch={(value) => this.onSearch(value)}
                                    value={this.state.searchValue}
                                    onChange={(e) => {
                                        this.setState({
                                            searchValue: e.target.value,
                                        });
                                    }}
                                    style={{width: 250}}
                                />
                            </div>
                            <div style={{marginLeft: "15px"}}>
                                <Button type={"primary"} onClick={this.reset}>
                                    重置
                                </Button>
                                <style>
                                    {` .ant-btn-primary{
                                            margin-right: 10px;
                                            background-color:${this.themeBgColor} !important;
                                            border-color:${this.themeBgColor} !important;}`}</style>
                            </div>
                        </div>
                        <div style={{marginRight: "15px"}}>
                            <span>目前在线人数:</span>
                            <span style={{marginLeft: "10px"}}>{totalCount}</span>
                        </div>
                    </div>
                    <div style={{maxHeight: 'calc(100vh - 247px)', padding: '0px 32px'}} className={"onlineNumberInfo"}>
                        <Scrollbars autoHeight autoHeightMax={'calc(100vh - 247px)'}>
                            <BaseTable columns={this.state.columns} dataSource={this.state.dataList}
                                       pagination={false}
                            />
                        </Scrollbars>
                        <style>{`
                            .onlineNumberInfo .ant-table-placeholder{
                               display:flex;
                               justify-content: center;
                               align-items: center;
                            //    height:500px;
                               border-bottom:none;
                            }
                        `}</style>
                    </div>
                    {this.renderFooter()}
                </div>
            </div>
        )
    }

    // 分页
    renderFooter(){
        let {start, size, listTotal} = this.state;
        return (
            <div className={'pagination'} style={{paddingTop: "17px", paddingBottom: "17px"}}>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={listTotal}
                    showTotal={total => `共 ${total} 条`}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                    hideOnSinglePage={false}
                />
            </div>
        )
    };

    pageChange = (page, pageSize) => {
        this.state.start = page;
        this.state.size = pageSize;
        this.getDataSource();
    }
}
